import React, { useState, useEffect } from 'react';
import { Box, Button } from '@mui/material';

import { useSelector } from 'react-redux';
import styles from './styles.module.scss';
import CardGiftcardIcon from "@mui/icons-material/CardGiftcard";
import CloseIcon from "@mui/icons-material/Close";
import ReferFriendModal from "@common/components/ReferFriendModal";
import ConfirmActionModal from "@common/components/ConfirmActionModal";
import { MS_PER_DAY } from "@src/vars";
import { isFeatureEnabled } from "@utils/helpers";


const RAFBlock = () => {
  const { selectedUser } = useSelector(state => state.user);
  const dimensions = useSelector(state => state.dimensions);
  const { featureFlags } = useSelector(state => state.featureFlags);
  const { configParameters } = useSelector(state => state.configParameters);
  const { referralsNumber } = useSelector(state => state.referrals);

  const [open, setOpen] = useState(false);
  const [openTable, setOpenTable] = useState(false);
  const [openRemoveConfirmation, setOpenRemoveConfirmation] = useState(false);
  const [openRemoveConfirmationParameters, setOpenRemoveConfirmationParameters] = useState(undefined);
  const [isDisplayed, setIsDisplayed] = useState(false);

  useEffect(() => {
    const hiddenToString = localStorage.getItem('HIDE_RAF_BLOCK_UNTIL');
    if (hiddenToString) {
      const hiddenToTime = Number(hiddenToString);
      if (!isNaN(hiddenToTime) && Date.now() < hiddenToTime) {
        setIsDisplayed(false);
      } else {
        localStorage.removeItem('HIDE_RAF_BLOCK_UNTIL');
        setIsDisplayed(true);
      }
    } else {
      setIsDisplayed(true);
    }
  }, []); //eslint-disable-line

  const hideThisBlock = () => {
    localStorage.setItem('HIDE_RAF_BLOCK_UNTIL', (Date.now() + MS_PER_DAY * 30).toString());
    setIsDisplayed(false);
  };

  const showHideBlockDialog = () => {
    setOpenRemoveConfirmationParameters({
      content: (<>
        <p>Do you want to hide <b>REFER A FRIEND</b> block for 30 days?</p>
        <p>You can always access it anytime from the <b>profile menu</b>.</p>
      </>),
      yesAction: () => {
        hideThisBlock();
      }
    });

    setOpenRemoveConfirmation(true);
  };

  if (!isDisplayed || !isFeatureEnabled(featureFlags, 'isReferFriendsInvitesActive')) return null;

  return (<>
    <Box sx={{ mb: 2, mt: 2 }} fullWidth className={styles.rafBlock}>
      <Box sx={{ mb: 2 }} className={styles.description}><div><span className={styles.semiBold}>Satisfied with Domium?</span></div><div>Refer a friend and earn {configParameters?.friendRefReward}</div></Box>
      <Button color="secondary" variant="outlined" className={styles.scheduleButton} fullWidth onClick={() => { setOpenTable(false); setOpen(true); }} data-testid="raf-open">
        <CardGiftcardIcon className={styles.iconInButton}/> REFER A FRIEND
      </Button>
      {!!referralsNumber && <Box sx={{ mt: 2 }} className={styles.description}><div className={styles.clickable} onClick={() => { setOpenTable(true); setOpen(true); }}>Track your {referralsNumber} referral{referralsNumber === 1 ? '' : 's'}</div></Box>}
      {!selectedUser?.id && (
        <CloseIcon className={styles.closeIcon} onClick={() => showHideBlockDialog()} data-testid="raf-hide" />
      )}
    </Box>
    <ReferFriendModal setOpen={setOpen} open={open} openTable={openTable} />
    <ConfirmActionModal
      open={openRemoveConfirmation}
      setOpen={setOpenRemoveConfirmation}
      parameters={openRemoveConfirmationParameters}
      title={'Hide "REFER A FRIEND"'}
    />
  </>);
};

export default RAFBlock;